
import React from 'react';

import { connect } from '../../../redux';
import AbstractDialogContainer, {
    abstractMapStateToProps
} from '../AbstractDialogContainer';

import { CustomModalTransition } from './CustomModal';

/**
 * Implements a DialogContainer responsible for showing all dialogs. Necessary
 * for supporting modal animations via CustomModalTransition.
 *
 * @augments AbstractDialogContainer
 */
class DialogContainer extends AbstractDialogContainer {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        if (this.props._rawDialog) {
            return this._renderDialogContent();
        }

        return (
            <CustomModalTransition>
                {this._renderDialogContent()}
            </CustomModalTransition>
        );
    }
}

export default connect(abstractMapStateToProps)(DialogContainer);
